//console.log('START');

const map = document.querySelector('.map__mapFrance');
//const liste = <?php echo json_encode($department_ids_all); ?>;
const liste = map_data.department_ids_all;
//console.log('Liste des départements pour l\'adhérent <?php the_title(); ?> :', liste);
// fonction pour calculer le centre du groupe de d
function getGroupCenter(groupIds) {
    let totalX = 0;
    let totalY = 0;
    let count = 0;

    groupIds.forEach(groupId => {
        const group = document.getElementById(groupId);
        if (group) {
            const bbox = group.getBBox();
            totalX += bbox.x + bbox.width / 2;
            totalY += bbox.y + bbox.height / 2;
            count++;
        }
    });

    const centerX = totalX / count;
    const centerY = totalY / count;
    return { centerX, centerY };
}

// Ajouter des points (cercles) pour chaque liste de départements
liste.forEach( (adherent,index) => {
    const departements = adherent.department_ids;
    
      // Calculer les coordonnées du centre du groupe de départements associé
    const center = getGroupCenter(departements);

    const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle.setAttribute('class', 'circle');

    // Positionner le point au centre du groupe de départements
    circle.setAttribute('cx', center.centerX+1.7);
    circle.setAttribute('cy', center.centerY+5);
    circle.setAttribute('r', '23');
     // Ajout d'une image de fond au cercle
    circle.style.backgroundImage = 'url(<?= get_template_directory_uri(); ?>/dist/img/marker.svg)';
    circle.style.backgroundSize = 'cover';				
    circle.style.fill = 'transparent';
    circle.style.strokeWidth = '2'; 

    // Ajouter le cercle à la carte SVG
    map.appendChild(circle);

    // Ajouter une image (marker) au centre du cercle
    const image = document.createElementNS('http://www.w3.org/2000/svg', 'image');
    const imageSize = 23.39; // Taille de l'image
    const imageSizeH = 29.38;
    const imageX = center.centerX - imageSize / 2; 
    const imageY = center.centerY - imageSize / 2; 



   // image.setAttribute('href', '../img/marker.svg');
    image.setAttribute('href', map_data.theme_directory_uri + '/dist/img/marker.svg');
    image.setAttribute('x', imageX);
    image.setAttribute('y', imageY);
    image.setAttribute('width', imageSize);
    image.setAttribute('height', imageSizeH);
    image.style.cursor = 'pointer';

    /*
    console.log('Valeur de imageSize :', imageSize);
    console.log('Valeur de imageX :', imageX);
    console.log('Valeur de imageY :', imageY);
    */

    // Ajouter l'image à la carte SVG
    map.appendChild(image);

    //animations au passage de la souris sur le marker
    image.addEventListener('mouseover', () => {
        const nomAdherent = adherent.nom_adherent;
        departements.forEach(departmentID => {
            const departmentGroup = document.getElementById(departmentID);
            departmentGroup.style.fill = '#85BC20';
            departmentGroup.style.stroke = '#85BC20';
            circle.style.fill = '#12405C'; 

            // afficher le nom de l'adhérent


         // Créer un rectangle pour servir de fond à la carte
         const cardRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
         cardRect.setAttribute('x', center.centerX + 10);
         cardRect.setAttribute('y', center.centerY - 115);
         cardRect.setAttribute('class', 'card-group');
         
         // Calculer la largeur du texte pour ajuster la taille du rectangle
         let nomAdherentText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
         nomAdherentText.textContent = nomAdherent;
         nomAdherentText.setAttribute('text-anchor', 'middle'); // Alignement horizontal du texte
         nomAdherentText.setAttribute('font-size', '14px'); // Taille de la police du texte
         nomAdherentText.setAttribute('fill', '#000'); // Couleur du texte
         nomAdherentText.setAttribute('class', ' nomAdherentText');
         map.appendChild(nomAdherentText); // Ajouter temporairement le texte pour obtenir sa largeur
         const textWidth = nomAdherentText.getBBox().width;
         const textHeight = nomAdherentText.getBBox().height;
         map.removeChild(nomAdherentText); // Supprimer le texte après avoir mesuré sa largeur
         
         cardRect.setAttribute('width', textWidth + 40); // Largeur du rectangle ajustée à la largeur du texte
         cardRect.setAttribute('height', 50); // Hauteur du rectangle
         cardRect.setAttribute('fill', '#fff'); // Couleur de fond de la carte
         cardRect.setAttribute('rx', 10); // Rayon X pour les coins arrondis
         cardRect.setAttribute('ry', 10);
         cardRect.setAttribute('stroke', '#152C51'); // Couleur de la bordure
        cardRect.setAttribute('stroke-width', '2'); 
         
         // Ajouter le rectangle à la carte SVG
         map.appendChild(cardRect);


         // Créer et ajouter le texte à la carte SVG, centré par rapport au rectangle
         const textX = center.centerX + 30 + (textWidth / 2); // Position X du texte centrée par rapport au rectangle
         const textY = center.centerY - 118 + (50 - textHeight) / 2 + textHeight;
        nomAdherentText.setAttribute('x', textX);
        nomAdherentText.setAttribute('y', textY);
        nomAdherentText.setAttribute('class', ' nomAdherentText');
        nomAdherentText.setAttribute('text-anchor', 'middle'); // Alignement horizontal du texte
        nomAdherentText.setAttribute('font-size', '14px'); // Taille de la police du texte
        nomAdherentText.setAttribute('fill', '#000');
         map.appendChild(nomAdherentText);
            
            //console.log("NOM ADHERENT: "+ nomAdherent);
            
        });
    });

    image.addEventListener('mouseout', () => {
        departements.forEach(departmentID => {
            const departmentGroup = document.getElementById(departmentID);
            departmentGroup.style.fill = '#152C51'; // Couleur d'origine
            departmentGroup.style.stroke = '#65805C'; // Couleur de la bordure d'origine d'un département 
            circle.style.fill = 'transparent'; center// Couleur d'origine

             // Supprimer le nom de l'adhérent lorsque la souris quitte l'image
             const cardGroup = document.querySelector('.card-group');
             const nomAdherentText = document.querySelector('.nomAdherentText');
             if (cardGroup) {
                 cardGroup.remove();
             }
             if (nomAdherentText) {
                nomAdherentText.remove();
            }
            
        });
    });

});


const paths = document.querySelectorAll('.land');

paths.forEach(path => {
    path.addEventListener('mouseover', () => {
    const departmentName = path.getAttribute('title');
    //console.log(departmentName);
    });
});

